import { APP_PROD_BASE_URL, APP_STAGE_BASE_URL } from '@src/constants';

export const getBaseUrl = (environment: string) => {
	return environment === 'prod' ? APP_PROD_BASE_URL : APP_STAGE_BASE_URL;
};
